<template>
  <div id="contact" class="flex flex-col justify-center items-center h-screen bg-gradient-to-b from-gray-50 to-gray-500 dark:from-dark-code dark:to-dark-rose sm:flex-row">
    <div class="w-11/12 sm:w-2/3">
      <h1 class="resume-section-title">{{ 'contact-title' | lang('contact') }}</h1>
      <div class="flex flex-col items-center fhd:my-12">
        <div v-for="(item, index) in contactList" :key="index" :title="item.title" class="w-full sm:w-1/2">
          <div class="flex flex-row justify-between items-end button-cta font-button-hero dark:text-gray-400">
            <component class="w-6 h-6 text-gray-50 sm:w-10 sm:h-10 4k:w-20 4k:h-20" :is="item.icon"></component>
            {{item.data}}
          </div>
        </div>
      </div>
      <div class="flex flex-row flex-wrap justify-center items-center mt-8 space-x-8 fhd:space-x-20">
        <div class="cursor-pointer focus:outline-none has-tooltip"
          @click="openLink(item.link)"
          v-for="(item, index) in iconList" :key="index">
          <component class="w-6 h-6 text-gray-50 sm:w-10 sm:h-10 4k:w-20 4k:h-20 dark:text-gray-400" :class="{'filter': item.title === 'Github'}" :is="item.icon"></component>
          <span class='px-4 py-2 mt-6 text-xl text-gray-700 bg-gray-100 rounded-xl shadow-lg tooltip 4k:text-5xl dark:bg-gray-700 dark:text-gray-300'>
            {{item.title}}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contactList: [
        { icon: 'IconEmail', title: 'Email', data: 'julieta.raw@gmail.com' },
        { icon: 'IconPhone', title: 'Phone number', data: '+54 351 788 9923' },
      ],
      iconList: [
        { icon: 'IconTelegram', title: 'Telegram', link: 'https://t.me/KaySoohyun' },
        { icon: 'IconLinkedin', title: 'Linkedin', link: 'https://www.linkedin.com/in/julieta-raw/' },
        { icon: 'IconGitlab', title: 'Gitlab', link: 'https://gitlab.com/KaySoohyun' },
        { icon: 'IconGithub', title: 'Github', link: 'https://github.com/KaySoohyun' },
        { icon: 'IconFolder', title: 'Portfolio source code', link: 'https://gitlab.com/kaysoohyun-portfolio' },
        { icon: 'IconCV', title: 'Link to cv', link: 'https://firebasestorage.googleapis.com/v0/b/portfolio-kaysoohyun.appspot.com/o/WiesztortJulietaCV.pdf?alt=media&token=ffa8b197-51cb-4bb9-9c75-8fa1558e9ee3' },
      ]
    };
  },
  methods: {
    openLink(href) {
      if (href) {
        window.open(href, '_blank');
      }
    }
  }
}
</script>

<style scoped>
.filter {
  filter: invert(1);
}

.tooltip {
  @apply invisible absolute;
}

.has-tooltip:hover .tooltip {
  @apply visible z-50;
}

.button-cta {
  padding: 0.7em 2.4em;
  margin: 1em 0.3em 0.3em 0;
}

.font-button-hero {
  @apply text-sm hd:text-base fhd:text-2xl 4k:text-5xl;
}
</style>